/**
 * 地图指标 data_up 字段：按序号 one、two、three、four… 定位（兼容旧 x / y / y_0 / label）
 * 1 → one（原 x）  2 → two（原 y）  3 → three（原 label）  4+ → four、five…
 */

const ORDINAL_FIELD_KEYS = [
  'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten',
]

export function getIndicatorFieldKey (index) {
  const i = Number(index)
  if (!Number.isFinite(i) || i < 1) return 'one'
  if (i <= ORDINAL_FIELD_KEYS.length) return ORDINAL_FIELD_KEYS[i - 1]
  return `col_${i}`
}

/** @param {object} row @param {number} index 1-based */
export function getIndicatorFieldByIndex (row, index) {
  if (!row || typeof row !== 'object') return undefined
  const key = getIndicatorFieldKey(index)
  if (Object.prototype.hasOwnProperty.call(row, key) && row[key] !== undefined) {
    return row[key]
  }
  if (index === 1 && row.x !== undefined) return row.x
  if (index === 2) {
    if (row.y !== undefined) return row.y
    if (row.y_0 !== undefined) return row.y_0
  }
  if (index === 3 && row.label !== undefined) return row.label
  if (index >= 4) {
    const legacy = row[`y_${index - 2}`]
    if (legacy !== undefined) return legacy
  }
  return undefined
}

export function isIndicatorNumericY (y) {
  if (y === null || y === undefined || y === '') return false
  if (typeof y === 'number' && Number.isFinite(y)) return true
  if (typeof y === 'string') {
    const n = Number(y)
    return Number.isFinite(n) && String(y).trim() !== ''
  }
  return false
}

/** 首行是否为列名表头（two 为非数值列名） */
export function isMapIndicatorColumnTitleRow (row) {
  return !!(row && !isIndicatorNumericY(getIndicatorFieldByIndex(row, 2)))
}

export function isMapIndicatorApiRow (row) {
  if (!row || typeof row !== 'object') return false
  if (Object.prototype.hasOwnProperty.call(row, 'col_0')) return false
  return getIndicatorFieldByIndex(row, 1) !== undefined ||
    getIndicatorFieldByIndex(row, 2) !== undefined ||
    row.x !== undefined ||
    row.y_0 !== undefined ||
    row.y !== undefined
}

/** 将单行规范为 one/two/three/…（读入时兼容 x/y/label） */
export function normalizeMapIndicatorRow (row) {
  if (!row || typeof row !== 'object') return row
  const out = { ...row }
  const maxIdx = Math.max(
    ORDINAL_FIELD_KEYS.length,
    ...Object.keys(row)
      .map(k => {
        const m = /^y_(\d+)$/.exec(k)
        if (m) return Number(m[1]) + 2
        const o = ORDINAL_FIELD_KEYS.indexOf(k)
        return o >= 0 ? o + 1 : 0
      }),
  )
  for (let i = 1; i <= maxIdx; i++) {
    const key = getIndicatorFieldKey(i)
    const v = getIndicatorFieldByIndex(row, i)
    if (v !== undefined) out[key] = v
  }
  return out
}

export function normalizeMapIndicatorDataList (dataList) {
  if (!Array.isArray(dataList)) return dataList
  return dataList.map(normalizeMapIndicatorRow)
}

/** 地图「大区说明」：three 为文案且非航线连线开关 */
export function isMapRegionLabelDataList (dataList) {
  if (!Array.isArray(dataList) || !dataList.length) return false
  let rows = dataList
  if (isMapIndicatorColumnTitleRow(dataList[0])) rows = dataList.slice(1)
  if (!rows.length) return false
  const three = getIndicatorFieldByIndex(rows[0], 3)
  if (three == null || three === '') return false
  if (three === 0 || three === '0' || three === 1 || three === '1') return false
  return !isIndicatorNumericY(three)
}
